import { gql } from '@apollo/client';

export const JOB_STAKEHOLDERS_QUERY = gql`
  query jobStakeholders($jobId: Int!) {
    jobStakeholders(jobId: $jobId) {
      id
      jobId
      role
      user {
        active
        email
        firstName
        lastName
      }
      userId
    }
  }
`;
